import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import API from '../../utils/ApiConfig';
import { COMPANY_DISCONNECT, GET_GL_COMPANIES } from '../../utils/ApiEndpoints';
import ErrorMessage from '../common/ErrorMessage/ErrorMessage';
import SuccessMessage from '../common/SuccessMessage/SuccessMessage';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

const GLSettings = props => {
  const [companies, setCompanies] = useState([]);
  const [connectProgress, setConnectProgress] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [isMultiCompanyQboEnabled, setMultiCompanyQboEnabled] = useState(false);

  const { t } = useTranslation();

  const closeErrorMessage = () => {
    setShowErrorMessage(false);
  };

  const tc = (e, data) => (data ? t(`glsettings:${e}`, data) : t(`glsettings:${e}`));

  useEffect(() => {
    API.get(GET_GL_COMPANIES)
      .then(data => {
        if (data.data) {
          setCompanies(data.data);
        }
      })
      .catch(err => {
        err && err.response && err.response.data && setErrorMessage(err.response.data.status);
        setShowErrorMessage(true);
      });
    const {
      services: { CommonService },
    } = props;
    CommonService.isEnableBudgeting().then(response => {
      setMultiCompanyQboEnabled(CommonService.isMultiCompanyQboEnabled);
    });
  }, []);

  const actionBodyTemplate = rowData => {
    return (
      <React.Fragment>
        {rowData.status === 'active' ? (
          <a href="#" className="GLSettingsCompanyLink" onClick={() => disconnect(rowData)}>
            {tc('GL_SETTINGS_COMPANY_DISCONNECT')}
          </a>
        ) : (
          <div className="QBOReconnectButton" onClick={() => reconnect(rowData)}></div>
        )}
      </React.Fragment>
    );
  };

  const disconnect = rowData => {
    if (connectProgress) {
      return false;
    }
    setConnectProgress(true);

    API.post(COMPANY_DISCONNECT, {
      realmId: rowData.realmId,
    })
      .then(data => {
        if (data.data && data.data.response === 'success') {
          rowData.status = 'inactive';
          setSuccessMessage('GL_SETTINGS_COMPANY_DISCONNECT_SUCCESSFULLY');
          setShowSuccessMessage(true);
        } else {
          setErrorMessage('GL_SETTINGS_COMPANY_DISCONNECT_FAILED');
          setShowErrorMessage(true);
        }
      })
      .catch(err => {
        err && err.response && err.response.data && setErrorMessage(err.response.data.status);
        setShowErrorMessage(true);
      })
      .finally(() => {
        setConnectProgress(false);
      });
  };

  const handleConnectToQBO = () => {
    console.log('handle', window);
    var currentDomain = window.location.hostname;
    var currentPath = window.location.pathname;
    var parts = currentDomain.split('.');
    var authDomain = currentDomain.replace(parts[0], 'glauth');
    var authURL = window.location.href.replace(currentDomain, authDomain);
    authURL = authURL.replace(currentPath, '/connectToQuickBook?isMultiComp=true&reconnectRealmId=&' + 'subDomain=' + parts[0]);
    window.location.href = authURL;
  };

  const reconnect = rowData => {
    var currentDomain = window.location.hostname;
    var currentPath = window.location.pathname;
    var parts = currentDomain.split('.');
    var authDomain = currentDomain.replace(parts[0], 'glauth');
    var authURL = window.location.href.replace(currentDomain, authDomain);
    authURL = authURL.replace(currentPath, '/connectToQuickBook?isMultiComp=false&reconnectRealmId=' + rowData.realmId + '&subdomain=' + parts[0]);
    window.location.href = authURL;
  };

  return (
    <React.Fragment>
      <div className="GLSettings">
        <div className="GLSettingsContainer">
          <div className="GLSettingsHeader">
            <div className="GLSettingsH1"> {tc('GL_SETTINGS_TITLE')}</div>
            <div className="GLSettingsH4"></div>
          </div>
          <div className="GLSettingsCompany">
            <label className="control-label GLSettingsCompanyLabel">{tc('GL_SETTINGS_COMPANY_LABEL')}</label>
            <div className="GLSettingsCompanyGrid">
              <DataTable value={companies} dataKey="realmId" selectionMode="single" resizableColumns columnResizeMode="fit" removableSort scrollable>
                {isMultiCompanyQboEnabled ? (
                  <Column
                    headerStyle={{ width: '50%' }}
                    field="companyName"
                    header={tc('GL_SETTINGS_COMPANY_NAME_HEADER')}
                    sortable
                    filter
                    filterPlaceholder={tc('GL_SETTINGS_COMPANY_NAME_PLACEHOLDER')}
                    filterMatchMode="contains"
                  />
                ) : (
                  <Column headerStyle={{ width: '50%' }} field="companyName" header={tc('GL_SETTINGS_COMPANY_NAME_HEADER')} />
                )}
                {isMultiCompanyQboEnabled ? (
                  <Column
                    headerStyle={{ width: '50%' }}
                    field="status"
                    header={tc('GL_SETTINGS_ACTIONS_HEADER')}
                    sortable
                    body={actionBodyTemplate}
                  />
                ) : (
                  <Column headerStyle={{ width: '50%' }} field="status" header={tc('GL_SETTINGS_ACTIONS_HEADER')} body={actionBodyTemplate} />
                )}
              </DataTable>
            </div>
          </div>
        </div>
        {isMultiCompanyQboEnabled ? <div className="QBOButton" onClick={handleConnectToQBO}></div> : ''}
      </div>

      <ErrorMessage open={showErrorMessage} handleClose={closeErrorMessage} message={errorMessage} />
      <SuccessMessage open={showSuccessMessage} setOpen={setShowSuccessMessage} message={tc(successMessage)} type="success" />
    </React.Fragment>
  );
};

export default GLSettings;